var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg134(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1301 9.56507C19.1301 11.4569 18.5691 13.3062 17.5181 14.8791C16.4671 16.4521 14.9732 17.6781 13.2255 18.402C11.4777 19.126 9.55445 19.3154 7.69901 18.9463C5.84357 18.5773 4.13924 17.6663 2.80154 16.3286C1.46384 14.9909 0.55286 13.2866 0.18379 11.4311C-0.18528 9.57568 0.0041401 7.65246 0.728097 5.90467C1.45205 4.15689 2.67803 2.66303 4.251 1.612C5.82397 0.560981 7.67327 -2.25594e-08 9.56507 0V4.78253C8.61917 4.78253 7.69452 5.06302 6.90803 5.58853C6.12155 6.11405 5.50856 6.86098 5.14658 7.73487C4.7846 8.60876 4.68989 9.57037 4.87443 10.4981C5.05896 11.4258 5.51445 12.278 6.1833 12.9468C6.85215 13.6157 7.70432 14.0712 8.63204 14.2557C9.55976 14.4402 10.5214 14.3455 11.3953 13.9835C12.2692 13.6216 13.0161 13.0086 13.5416 12.2221C14.0671 11.4356 14.3476 10.511 14.3476 9.56507H19.1301Z",
    fill: "#FFB600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1291 4.78235H19.1281V8.69543H14.3459V4.78235H10.4338V0.00012207H19.1291V4.78235Z",
    fill: "#FFB600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg134);
export default __webpack_public_path__ + "static/media/svg134.e3c04ee726eab39d8531fa0a8d702ae3.svg";
export { ForwardRef as ReactComponent };